import { render, staticRenderFns } from "./UserAppSettings.vue?vue&type=template&id=21589f00&"
import script from "./UserAppSettings.vue?vue&type=script&lang=js&"
export * from "./UserAppSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports